import { Input } from "@alme/ui-web/types/input";
import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";
import LiveChatState from '@alme/ui-web/modules/livechat-foundation/src/livechat-state';

export default class ProductInfoRequestProcessor {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;
    _liveChatState: LiveChatState;

    constructor(settings: AlightCustomSettingsType, liveChatState: LiveChatState) {
        this._settings = settings;
        this._liveChatState = liveChatState;
    }

    initialize(store: Store<AlightStateType>){
        this._store = store;
    }

    process(input: Input) {
        if (!this.doesHandle(input)) return input;
        let inputParameters: any = {};
        if (input.parameters) {
            inputParameters = input.parameters;
        }

        if (!inputParameters.Context) {
            inputParameters.Context = {};
        }

        inputParameters.Context.ProductInfo = this.getProductInfoFromStore();
        inputParameters.Context.almeHost = `${this._settings.AlmeAPI.ALME_API_PROTOCOL}${this._settings.AlmeAPI.ALME_API_HOSTNAME}`;

        return Object.assign({}, input, { parameters: inputParameters });
    }

    getProductInfoFromStore() {
        return this._store?.getState().Window.productPayload;
    }

    doesHandle(input: Input) {
        return !this._liveChatState.isOnlineStatus(this._liveChatState.sessionStatus);
    }
}



// WEBPACK FOOTER //
// ./modules/productinfo/nextit-request-processor-productinfo-aon.ts